import DeliveryService from "../DeliveryService"


const Driver = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    gets(r) {
        let url = '/console/drivers'
        if (r != undefined) {
            url = '/console/enterprises?' + r
        }
        return DeliveryService.get(url)
    },
    create(data) {
        let url = '/console/drivers'
        return DeliveryService.post(url, data)
    },
    getQuotation(data){
        let url = '/console/orders/'+data.order_id+'/driver-quotation'
        return DeliveryService.post(url, data)
    },
    requestDriver(data){
        let url = '/console/orders/'+data.order_id+'/driver-request'
        return DeliveryService.post(url, data)
    }
}
export default Driver